import _asyncToGenerator from "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.8.0_@playwright+test@1.57.0_react-_dcc27c9c099c584e88412888af34645b/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/@babel+runtime@7.14.6/node_modules/@babel/runtime/regenerator/index.js";
import serverSideCalculations from 'shared/graphql/calculations/mutations/server-side-calculations.gql';
import { ecommCalculationsInput } from '../helpers/calculations/helpers';
var handleLegacyCalculationsRequest = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var apolloClient, legacyInput;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          apolloClient = _ref.apolloClient, legacyInput = _ref.legacyInput;
          return _context.abrupt("return", apolloClient.mutate({
            mutation: serverSideCalculations,
            variables: {
              input: legacyInput
            }
          }));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function handleLegacyCalculationsRequest(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export function serverSideComputations(_x2, _x3, _x4, _x5) {
  return _serverSideComputations.apply(this, arguments);
}
function _serverSideComputations() {
  _serverSideComputations = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, logger, apolloClient, priceService) {
    var _response$data;
    var _data$dispensary, response, legacyInput, _data$dispensary2, legacyOutput, _data$dispensary3;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(!data.dispensary || !data.cart || !apolloClient)) {
            _context2.next = 3;
            break;
          }
          logger.error('Missing required data for legacy calculations', {
            hasDispensary: !!data.dispensary,
            hasCart: !!data.cart,
            hasApolloClient: !!apolloClient,
            dispensaryId: (_data$dispensary = data.dispensary) === null || _data$dispensary === void 0 ? void 0 : _data$dispensary.id,
            priceService: priceService
          });
          return _context2.abrupt("return", {});
        case 3:
          legacyInput = ecommCalculationsInput(data, priceService);
          _context2.prev = 4;
          _context2.next = 7;
          return handleLegacyCalculationsRequest({
            apolloClient: apolloClient,
            logger: logger,
            legacyInput: legacyInput
          });
        case 7:
          response = _context2.sent;
          _context2.next = 13;
          break;
        case 10:
          _context2.prev = 10;
          _context2.t0 = _context2["catch"](4);
          logger.error('Error in legacy calculations API call', {
            dispensaryId: (_data$dispensary2 = data.dispensary) === null || _data$dispensary2 === void 0 ? void 0 : _data$dispensary2.id,
            priceService: priceService,
            error: _context2.t0.message
          });
        case 13:
          legacyOutput = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.serverSideCalculations;
          if (legacyOutput) {
            _context2.next = 17;
            break;
          }
          logger.error('Empty response from legacy calculations API', {
            dispensaryId: (_data$dispensary3 = data.dispensary) === null || _data$dispensary3 === void 0 ? void 0 : _data$dispensary3.id,
            priceService: priceService
          });
          return _context2.abrupt("return", {});
        case 17:
          return _context2.abrupt("return", legacyOutput);
        case 18:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[4, 10]]);
  }));
  return _serverSideComputations.apply(this, arguments);
}